import {AbstractVisualFeature} from '#core/application/modules/visual-feature.js';

import {Markets} from '../markets.js';

import {eventTipsFactory} from './event-tips.factory.js';

import PALETTE_SCHEMA from './event-tips.palette-schema.yaml';

class EventTipsFeature extends AbstractVisualFeature {
    get name() {
        return 'EventTips';
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getSerializableVisualConfig(PALETTE) {
        return eventTipsFactory(PALETTE);
    }
}

new EventTipsFeature(Markets);
